import React, { useState } from "react";
import "./mainLayout.scss";
import Countdown from "react-countdown";
import { dateDiffMilliSeconds } from "../../utils/utils.js";
import { useGlobalState } from "../../GlobalStates.js";
import CloseIcon from "@mui/icons-material/Close";
import useIsAndroid from "../../customHooks/useIsAndroid.js";
import { DownloadAppModal } from "../DownloadAppModal.js";
import { useNavigate, useLocation } from "react-router-dom";
import { Stack } from "@mui/system";
import { useTranslation } from "react-i18next";
import { useIsMobile } from "../../hooks/responsive.js";
import dayjs from "dayjs";

const DownloadAppFooter = ({ children }) => {
  const { t } = useTranslation();
  const [{ promotions: tPromotions }] = useGlobalState("translations");
  const [searchMobile, setSearchMobile] = useGlobalState("searchMobile");

  const isMobile = useIsMobile();

  const isInApp = window.isInApp;
  const [showAppHeader, setShowAppHeader] = useState(true);
  const [openDownloadAppModal, setOpenDownloadAppModal] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const isAndroid = useIsAndroid();

  const handleDownloadClick = () => {
    if (isMobile) {
      const appStoreRedirect = isAndroid
        ? "https://play.google.com/store/apps/details?id=com.sotravel.sotravel"
        : "https://apps.apple.com/app/id6447177449";
      window.open(appStoreRedirect);
      setShowAppHeader(false);
    } else {
      setOpenDownloadAppModal(true);
    }
  };

  const handleSeeDealsClick = () => {
    window.open(promotion?.generalPromo.cta, "_blank");
  };

  const shouldShowAppHeader = () => {
    if (
      location.pathname.toLowerCase().includes("/all-trips") &&
      showAppHeader &&
      !isInApp &&
      localStorage.getItem("JWT_TOKEN") &&
      !searchMobile
    ) {
      return true;
    }
  };

  const [promotion, setPromotion] = useGlobalState("promotion");

  const shouldShowPromoFooter = () => {
    if (
      (location.pathname === "/" ||
        location.pathname.toLowerCase().includes("/all-trips")) &&
      showAppHeader &&
      promotion?.generalPromo &&
      !searchMobile &&
      Object.keys(promotion?.generalPromo).length > 0
    ) {
      return true;
    }

    return false;
  };

  if (shouldShowPromoFooter()) {
    return (
      <footer
        className={`
          tw-fixed tw-bottom-0 tw-w-full tw-z-[99999]
          tw-bg-black tw-text-yellow-400
          tw-transition-all tw-duration-200 tw-ease-in-out
          tw-shadow-lg tw-shadow-black/20
          tw-cursor-pointer
          ${isMobile ? "tw-h-20" : "tw-h-24"}
        `}
        onClick={() => window.open(promotion?.generalPromo.cta, "_blank")}
      >
        <button
          className="tw-absolute tw-top-2 tw-right-2 tw-text-white tw-p-1 tw-rounded-full hover:tw-bg-white/10"
          onClick={(e) => {
            e.stopPropagation();
            setShowAppHeader(false);
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="tw-h-5 tw-w-5"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              fillRule="evenodd"
              d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
              clipRule="evenodd"
            />
          </svg>
        </button>

        <div className="tw-flex tw-items-center tw-justify-between tw-px-4 tw-h-full tw-max-w-7xl tw-mx-auto">
          <div className="tw-flex-1 tw-flex tw-flex-col ">
            <div className="tw-space-y-1">
              <h3 className="tw-text-sm md:tw-text-base tw-font-extrabold tw-truncate">
                {tPromotions[promotion.generalPromo.id]?.name ||
                  promotion.generalPromo.name}
              </h3>
              <button
                onClick={handleSeeDealsClick}
                className="tw-px-4 tw-py-2 tw-bg-[deepskyblue] tw-text-white tw-font-bold tw-text-sm tw-rounded-lg tw-duration-200"
              >
                {t("browse_deals", {
                  defaultValue: "BROWSE DEALS",
                })}
              </button>
            </div>
          </div>

          {location.pathname.toLowerCase().includes("/all-trips") ? (
            <div className="tw-ml-4">
              <Countdown
                date={
                  dayjs().isBefore(dayjs(promotion?.generalPromo.launch_time))
                    ? promotion?.generalPromo.launch_time
                    : promotion?.generalPromo.promo_end_date_inclusive
                }
                renderer={({ days, hours, minutes, seconds }) => (
                  <div className="tw-flex tw-flex-col tw-items-center tw-space-y-1">
                    {days > 0 && (
                      <p className="tw-text-xs tw-font-bold tw-text-white">
                        {dayjs().isBefore(
                          dayjs(promotion?.generalPromo.launch_time)
                        )
                          ? t("daystart", { count: days })
                          : t("dayleft", { count: days })}
                      </p>
                    )}

                    <div className="tw-flex tw-items-center tw-space-x-1">
                      <div className="tw-bg-white tw-rounded-lg tw-px-2 tw-py-1">
                        <span className="tw-text-black tw-font-bold tw-text-sm">
                          {String(hours).padStart(2, "0")} {t("hours")}
                        </span>
                      </div>
                      <span className="tw-text-white">:</span>
                      <div className="tw-bg-white tw-rounded-lg tw-px-2 tw-py-1">
                        <span className="tw-text-black tw-font-bold tw-text-sm">
                          {String(minutes).padStart(2, "0")} {t("minutes")}
                        </span>
                      </div>
                      {!isMobile && (
                        <>
                          <span className="tw-text-white">:</span>
                          <div className="tw-bg-white tw-rounded-lg tw-px-2 tw-py-1">
                            <span className="tw-text-black tw-font-bold tw-text-sm">
                              {String(seconds).padStart(2, "0")} {t("seconds")}
                            </span>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                )}
              />
            </div>
          ) : (
            <p className="tw-text-xs md:tw-text-sm tw-font-medium tw-text-white/80 tw-line-clamp-2">
              {tPromotions[promotion.generalPromo.id]?.description ||
                promotion.generalPromo.description}
            </p>
          )}
        </div>
      </footer>
    );
  } else if (shouldShowAppHeader())
    return (
      <footer
        className="tw-fixed tw-bottom-0 tw-w-full tw-z-[99999] tw-bg-gradient-to-br tw-from-sky-400 tw-via-sky-500 tw-to-sky-600 tw-backdrop-blur-xl tw-flex tw-items-center tw-justify-center tw-shadow-xl"
        style={{ height: isMobile ? "5rem" : "6rem" }}
      >
        <button
          className="tw-absolute tw-top-3 tw-right-3 tw-text-white/90 tw-p-1.5 tw-rounded-full hover:tw-bg-white/20 tw-transition-all tw-duration-300 tw-backdrop-blur-sm"
          onClick={() => setShowAppHeader(false)}
        >
          <CloseIcon className="tw-w-3.5 tw-h-3.5" />
        </button>

        <div className="tw-flex tw-flex-row tw-w-full tw-items-center tw-justify-between tw-px-4 md:tw-px-8 tw-max-w-6xl">
          <div className="tw-flex tw-items-center tw-space-x-3 md:tw-space-x-5">
            <div className="tw-relative tw-group tw-flex-none">
              <img
                src="/new_logo/app-icon.png"
                className="tw-h-10 tw-w-10 md:tw-h-14 md:tw-w-14 tw-rounded-lg tw-object-cover tw-shadow-lg tw-transition-transform tw-duration-300 group-hover:tw-scale-105"
                alt="Sotravel App Icon"
              />
              <div className="tw-absolute tw-inset-0 tw-rounded-lg tw-ring-2 tw-ring-white/30 tw-transition-opacity tw-duration-300 group-hover:tw-ring-white/40"></div>
            </div>

            <div className="tw-flex tw-flex-col tw-justify-center tw-space-y-0.5 md:tw-space-y-1.5">
              <span className="tw-text-white tw-text-sm md:tw-text-base tw-font-extrabold tw-tracking-tight tw-drop-shadow-sm">
                {t("sotravel_app", {
                  defaultValue: "SOTRAVEL APP",
                })}
              </span>
              <span className="tw-text-white/90 tw-text-xs md:tw-text-sm tw-font-medium tw-tracking-wide tw-line-clamp-2 md:tw-line-clamp-1">
                {t("get_access_free_reservations", {
                  defaultValue: "Get access to free reservations and deals",
                })}
              </span>
            </div>
          </div>

          <button
            className="tw-px-4 md:tw-px-7 tw-py-2 md:tw-py-3 tw-bg-white tw-text-deepskyblue tw-font-bold tw-text-xs md:tw-text-sm 
              tw-rounded-xl hover:tw-bg-opacity-95 tw-transition-all tw-duration-300 tw-shadow-lg
              hover:tw-shadow-xl hover:tw-scale-105 active:tw-scale-100 tw-backdrop-blur-sm
              tw-border tw-border-white/20 tw-whitespace-nowrap tw-ml-2 md:tw-ml-0"
            onClick={handleDownloadClick}
          >
            {t("download", {
              defaultValue: "DOWNLOAD",
            })}
          </button>
        </div>

        {openDownloadAppModal && (
          <DownloadAppModal
            open={openDownloadAppModal}
            handleClose={() => {
              setOpenDownloadAppModal(false);
              setShowAppHeader(false);
            }}
          />
        )}
      </footer>
    );
};

export default DownloadAppFooter;
